import { Layer, LayerInstance } from '../core/layer';

const layerStorage: Record<string, Layer> = {};
const layerInstanceStorage: Record<string, LayerInstance> = {};
const cdnStorage: Record<string, boolean> = {};
const promiseStorage: Map<string, Promise<boolean>> = new Map();

function isLink(url: string) {
  const linkRegex = /^(https?:\/\/)(cdn\.)?[\w-]+(\.[\w-]+)+(:\d+)?(\/[^\s]*)?$/i;
  return linkRegex.test(url);
}

function checkCDN(url: string) {
  return !!cdnStorage[url];
}

function validateViewType(layer: Layer) {
  if (
    !layer.isNormalLayer &&
    !layer.isStandardChartLayer &&
    !layer.isHXKLineLayer &&
    !layer.isExternalLayer
  ) {
    console.error('缺少视图类型定义');
  }
}

export async function loadScriptFromLayer(layer: Layer) {
  if (!layer?.cdn) {
    return;
  }
  const cdnArray = Array.isArray(layer.cdn) ? layer.cdn : [layer.cdn];
  const loadPromises = cdnArray.map(url => {
    if (!isLink(url) || checkCDN(url)) {
      return Promise.resolve(false);
    }
    if (promiseStorage.has(url)) {
      return promiseStorage.get(url);
    }

    const scriptPromise = new Promise<boolean>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => {
        cdnStorage[url] = true;
        resolve(true);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    promiseStorage.set(url, scriptPromise);

    return scriptPromise;
  });
  await Promise.all(loadPromises);
}

export function registerLayer(layer: Layer) {
  validateViewType(layer);
  if (!layer.visInfo.standers) {
    // eslint-disable-next-line no-param-reassign
    layer.visInfo.standers = 'f10';
  }

  // 保存到layer存储
  layerStorage[layer.type] = layer;
}

export function registerLayerInstance(type: string, instance: LayerInstance) {
  layerInstanceStorage[type] = instance;
}

export function hasLayer(type: string): boolean {
  return !!layerStorage[type];
}

export function hasLayerInstance(type: string): boolean {
  return !!layerInstanceStorage[type];
}

export function getLayer(type: string): Layer {
  if (!hasLayer(type)) {
    throw Error(`There is no layer definition of type ${type} registered in the component library`);
  }
  return layerStorage[type];
}

export function getLayerInstance(type: string): LayerInstance | undefined {
  return layerInstanceStorage[type];
}
